// Preselect the Appstle "Subscribe & Save" option instead of one-time purchase.
// Loaded with defer, so it runs after Appstle's inline RS.Config is defined
// but before Appstle's own deferred widget script (later in the document) reads it.
if (window.RS && window.RS.Config) {
  window.RS.Config.subscriptionOptionSelectedByDefault = true;
}
